import { useEffect } from "react";
import { history, MeuUsuarioService, SessionService } from "../../services";
import { StorageHelper } from "../../helpers";
import "./loading-pdv.style.scss";

const LoadingPdvView = () => {
  const meuUsuarioService = new MeuUsuarioService();
  const sessionService = new SessionService();
  const storageHelper = new StorageHelper();
  const images = {
    logo: "https://public.siafevolution.com.br/icon-lite.svg",
  };

  useEffect(() => {
    verificaToken();
  }, []);

  const verificaToken = () => {
    const pdvOnLineStorage = sessionService.getDadosOffline();
    const token = storageHelper.getLocal("token");
    if (
      pdvOnLineStorage &&
      !pdvOnLineStorage.pdvOnLine &&
      token === "offline-token"
    ) {
      return history.push("/pdv");
    }
    if (!token) {
      return history.push("/login");
    }
    meuUsuarioService.validarToken().then((result) => {
      if (!result.isAxiosError) {
        return history.push("/pdv");
      }
      return sessionService.deslogar();
    });
  };

  return (
    <div className="inicio-container">
      <img src={images.logo} className="inicio-container-img" alt="" />
    </div>
  );
};

export default LoadingPdvView;
